"use strict";
/* --------------------------------------------------------------------------------------------
 *  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinuxGlobalInstaller = void 0;
const os = require("os");
const path = require("path");
const TypescriptUtilities_1 = require("../Utils/TypescriptUtilities");
const CacheTimeConstants_1 = require("./CacheTimeConstants");
const DotnetInstall_1 = require("./DotnetInstall");
const IGlobalInstaller_1 = require("./IGlobalInstaller");
const LinuxVersionResolver_1 = require("./LinuxVersionResolver");
const StringConstants_1 = require("./StringConstants");
class LinuxGlobalInstaller extends IGlobalInstaller_1.IGlobalInstaller {
    constructor(acquisitionContext, utilContext, fullySpecifiedDotnetVersion) {
        super(acquisitionContext, utilContext);
        this.linuxSDKResolver = new LinuxVersionResolver_1.LinuxVersionResolver(acquisitionContext, utilContext);
        this.version = fullySpecifiedDotnetVersion;
    }
    installSDK() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.linuxSDKResolver.Initialize();
            return (0, TypescriptUtilities_1.executeWithLock)(this.acquisitionContext.eventStream, false, (0, StringConstants_1.GLOBAL_INSTALL_STATE_MODIFIER_LOCK)(this.acquisitionContext.installDirectoryProvider, (0, DotnetInstall_1.GetDotnetInstallInfo)(this.version, 'sdk', 'global', os.arch())), CacheTimeConstants_1.GLOBAL_LOCK_PING_DURATION_MS, this.acquisitionContext.timeoutSeconds * 1000, () => __awaiter(this, void 0, void 0, function* () {
                return this.linuxSDKResolver.ValidateAndInstallSDK(this.version);
            }));
        });
    }
    uninstallSDK() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.linuxSDKResolver.Initialize();
            return this.linuxSDKResolver.UninstallSDK(this.version);
        });
    }
    getExpectedGlobalSDKPath(specificSDKVersionInstalled_1, installedArch_1) {
        return __awaiter(this, arguments, void 0, function* (specificSDKVersionInstalled, installedArch, macPathShouldExist = true) {
            yield this.linuxSDKResolver.Initialize();
            const dotnetFolder = (yield (yield this.linuxSDKResolver.distroCall()).getDotnetVersionSupportStatus(specificSDKVersionInstalled, 'sdk')) === "DISTRO" /* DotnetDistroSupportStatus.Distro */ ?
                (yield this.linuxSDKResolver.distroCall()).getExpectedDotnetDistroFeedInstallationDirectory() :
                (yield this.linuxSDKResolver.distroCall()).getExpectedDotnetMicrosoftFeedInstallationDirectory();
            return path.join(dotnetFolder, (0, TypescriptUtilities_1.getDotnetExecutable)());
        });
    }
    getGlobalSdkVersionsInstalledOnMachine() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.linuxSDKResolver.Initialize();
            return (yield this.linuxSDKResolver.distroCall()).getInstalledDotnetSDKVersions();
        });
    }
}
exports.LinuxGlobalInstaller = LinuxGlobalInstaller;
//# sourceMappingURL=LinuxGlobalInstaller.js.map